import history from '../history';
import { useNavigate } from 'react-router-dom'

const useSearchQuery = {
	add: (name, value) => {

		const navigate = useNavigate()

		const isObject =
			typeof name === 'object' && !Array.isArray(name) && name !== null;

		const currentSearchParams = history?.location?.search?.substring(1);
		const existing = currentSearchParams
			? JSON.parse(
					'{"' +
						currentSearchParams.replace(/&/g, '","').replace(/=/g, '":"') +
						'"}',
					function (key, value) {
						return key === '' ? value : decodeURIComponent(value);
					}
			  )
			: {};

		const filters = {
			...existing,
			...(isObject ? name : { [name]: value }),
		};
		delete filters?.pageSize;
		const search = new URLSearchParams();

		Object.keys(filters)
			.filter((key) => filters[key])
			.map((key) => search.append(key, filters[key]));

			navigate({
				pathname: history.location.pathname,
				search: search.toString(),
			}, { replace: true });

	},
	remove: (name) => {
		const navigate = useNavigate()

		const isArr = Array.isArray(name);
		const search = new URLSearchParams();

		const currentSearchParams = history?.location?.search?.substring(1);
		const existing = currentSearchParams
			? JSON.parse(
					'{"' +
						currentSearchParams.replace(/&/g, '","').replace(/=/g, '":"') +
						'"}',
					function (key, value) {
						return key === '' ? value : decodeURIComponent(value);
					}
			  )
			: {};

		Object.keys(existing)
			.filter((key) => existing[key])
			.map((key) => search.append(key, existing[key]));
		search.delete('pageSize');

		if (isArr) {
			name?.map((nam) => search.delete(nam));
		} else {
			search.delete(name);
		}

		navigate({
			pathname: history.location.pathname,
			search: search.toString(),
		});
	},
};

export default useSearchQuery;
